import { boxAspectRatio, threshhold } from 'ha/components/Listing/constants';

export default function shouldFixImage({
  naturalWidth,
  naturalHeight,
}: {
  naturalWidth: number;
  naturalHeight: number;
}) {
  const ratio = naturalWidth / naturalHeight;
  const diffRatio = boxAspectRatio - ratio;

  if (diffRatio > 0 && diffRatio <= threshhold) {
    return true;
  }

  return false;
}
